import { CTA_DISABLE_DWEB } from 'constants/experiments';
import { getEligibleForVariant } from 'helpers/experimentV2';
import { useSelector } from 'react-redux';
import { State } from 'store/types';

const useShouldDisableCta = () => {
  const disableCta = useSelector((state: State) =>
    getEligibleForVariant(state, CTA_DISABLE_DWEB, 'A')
  );
  return disableCta;
};

export default useShouldDisableCta;
